import { RetryLink } from 'apollo-link-retry';

function operationHasMutation(operation) {
  try {
    return operation.query.definitions.some(
      (def) => def.operation === 'mutation'
    );
  } catch (e) {
    console.error(e);
    return true;
  }
}

export function createRetryOnNetworkErrorLink() {
  return new RetryLink({
    delay: {
      initial: 300,
      max: Infinity,
      jitter: true
    },
    attempts: {
      max: 5,
      retryIf: (error, _operation) => {
        // Если есть хоть одна мутация в запросе - не повторяем,
        // т.к. может изменение внестись два раза
        if (operationHasMutation(_operation)) {
          return false;
        }
        // Ошибка может быть как ошибкой graphql, так и ошибкой сети
        if (error) {
          // Иногда fetch возвращает TypeError, если запрос не удается выполнить
          if (error instanceof TypeError) {
            return error.message === 'Failed to fetch';
          }
          // Если ошибка сервера, то пробуем повторить
          if (error.statusCode >= 500 && error.statusCode <= 599) {
            return true;
          }
        }
        return false;
      }
    }
  });
}
